var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11861",
    d: "M17.429 8a6.429 6.429 0 1 0 6.429 6.429A6.429 6.429 0 0 0 17.429 8z",
    transform: "translate(.571 -.286)",
    style: {
      fill: "#024da1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11862",
    d: "M20 2a18 18 0 1 0 18 18A18 18 0 0 0 20 2zm10.276 29.476a6.431 6.431 0 0 0-6.419-6.333h-7.714a6.431 6.431 0 0 0-6.419 6.333 15.429 15.429 0 1 1 20.552 0z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#024da1"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutLogo);
export default __webpack_public_path__ + "static/media/logout-Logo.6136cd290c7528e8064382f427adcf8c.svg";
export { ForwardRef as ReactComponent };